"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.issueToken = issueToken;
var __typia_transform__randomPick = __importStar(require("typia/lib/internal/_randomPick.js"));
var __typia_transform__randomString = __importStar(require("typia/lib/internal/_randomString.js"));
var __typia_transform__randomNumber = __importStar(require("typia/lib/internal/_randomNumber.js"));
var __typia_transform__assertGuard = __importStar(require("typia/lib/internal/_assertGuard.js"));
var NestiaSimulator_1 = require("@nestia/fetcher/lib/NestiaSimulator");
var PlainFetcher_1 = require("@nestia/fetcher/lib/PlainFetcher");
var typia_1 = __importDefault(require("typia"));
/**
 * Issue Alfred tokens (KV token + refresh token).
 *
 * `grant_type: firebase` exchanges a Firebase ID token and replaces the `fir_token` flow of the
 * legacy api-server `POST /v2/user/authbytoken`. The request must carry a valid Firebase App Check
 * token in `X-Firebase-AppCheck`. The account is created on first sign-in.
 *
 * @tag token
 * @summary Issue a KV token and a refresh token
 * @throws 400 malformed body or unsupported grant_type
 * @throws 401 missing or invalid App Check token (`unauthorized`), invalid Firebase ID token (`token_invalid`) or expired Firebase ID token (`token_expired`)
 * @throws 403 the Firebase user has no email, or the App Check app is not allowed
 * @throws 500 user-service or token storage failure
 *
 * @controller TokenController.issueToken
 * @path POST /auth/v1/token
 * @nestia Generated by Nestia - https://github.com/samchon/nestia
 */
function issueToken(connection, body) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, true === connection.simulate
                    ? issueToken.simulate(connection, body)
                    : PlainFetcher_1.PlainFetcher.fetch(__assign(__assign({}, connection), { headers: __assign(__assign({}, connection.headers), { "Content-Type": "application/json" }) }), __assign(__assign({}, issueToken.METADATA), { template: issueToken.METADATA.path, path: issueToken.path() }), body)];
        });
    });
}
(function (issueToken) {
    issueToken.METADATA = {
        method: "POST",
        path: "/auth/v1/token",
        request: {
            type: "application/json",
            encrypted: false,
        },
        response: {
            type: "application/json",
            encrypted: false,
        },
        status: 201,
    };
    issueToken.path = function () { return "/auth/v1/token"; };
    issueToken.random = function () { return (function () { var _ro0 = function (_recursive, _depth) {
        var _a;
        if (_recursive === void 0) { _recursive = false; }
        if (_depth === void 0) { _depth = 0; }
        return ({
            status_code: __typia_transform__randomPick._randomPick([
                function () { return "succeeded"; },
                function () { return "parameter_invalid"; },
                function () { return "token_expired"; },
                function () { return "token_invalid"; },
                function () { return "unauthorized"; },
                function () { return "forbidden"; },
                function () { return "not_found"; },
                function () { return "operation_conflict"; },
                function () { return "resource_already_exist"; },
                function () { return "payload_too_large"; },
                function () { return "unprocessable_entity"; },
                function () { return "already_assigned"; },
                function () { return "quota_exceeded"; },
                function () { return "server_error"; }
            ])(),
            status_message: ((_a = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _a !== void 0 ? _a : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            data: _ro1(_recursive, _recursive ? 1 + _depth : _depth)
        });
    }; var _ro1 = function (_recursive, _depth) {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (_recursive === void 0) { _recursive = false; }
        if (_depth === void 0) { _depth = 0; }
        return ({
            kv_token: ((_a = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _a !== void 0 ? _a : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            iat: ((_b = _generator === null || _generator === void 0 ? void 0 : _generator.number) !== null && _b !== void 0 ? _b : __typia_transform__randomNumber._randomNumber)({
                type: "number"
            }),
            exp: ((_c = _generator === null || _generator === void 0 ? void 0 : _generator.number) !== null && _c !== void 0 ? _c : __typia_transform__randomNumber._randomNumber)({
                type: "number"
            }),
            refresh_token: ((_d = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _d !== void 0 ? _d : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            uid: ((_e = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _e !== void 0 ? _e : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            jid: ((_f = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _f !== void 0 ? _f : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            email: ((_g = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _g !== void 0 ? _g : __typia_transform__randomString._randomString)({
                type: "string"
            }),
            login_type: ((_h = _generator === null || _generator === void 0 ? void 0 : _generator.string) !== null && _h !== void 0 ? _h : __typia_transform__randomString._randomString)({
                type: "string"
            })
        });
    }; var _generator; return function (generator) {
        _generator = generator;
        return _ro0();
    }; })()(); };
    issueToken.simulate = function (connection, body) {
        var assert = NestiaSimulator_1.NestiaSimulator.assert({
            method: issueToken.METADATA.method,
            host: connection.host,
            path: issueToken.path(),
            contentType: "application/json",
        });
        assert.body(function () { return (function () { var _io0 = function (input) { return "firebase" === input.grant_type && ("string" === typeof input.id_token && 1 <= input.id_token.length) && ("string" === typeof input.resource && (input.resource.length <= 128 && RegExp("^ivuu[0-9]{1,2}[^\\u0000-\\u001F\\u007F]*$").test(input.resource))); }; var _ao0 = function (input, _path, _exceptionable) {
            if (_exceptionable === void 0) { _exceptionable = true; }
            return ("firebase" === input.grant_type || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".grant_type",
                expected: "\"firebase\"",
                value: input.grant_type
            }, _errorFactory)) && ("string" === typeof input.id_token && (1 <= input.id_token.length || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".id_token",
                expected: "string & MinLength<1>",
                value: input.id_token
            }, _errorFactory)) || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".id_token",
                expected: "(string & MinLength<1>)",
                value: input.id_token
            }, _errorFactory)) && ("string" === typeof input.resource && (input.resource.length <= 128 || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".resource",
                expected: "string & MaxLength<128>",
                value: input.resource
            }, _errorFactory)) && (RegExp("^ivuu[0-9]{1,2}[^\\u0000-\\u001F\\u007F]*$").test(input.resource) || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".resource",
                expected: "string & Pattern<\"^ivuu[0-9]{1,2}[^\\\\u0000-\\\\u001F\\\\u007F]*$\">",
                value: input.resource
            }, _errorFactory)) || __typia_transform__assertGuard._assertGuard(_exceptionable, {
                method: "typia.assert",
                path: _path + ".resource",
                expected: "(string & MaxLength<128> & Pattern<\"^ivuu[0-9]{1,2}[^\\\\u0000-\\\\u001F\\\\u007F]*$\"> & Example<\"ivuu31WebViewer2120E1C80000\">)",
                value: input.resource
            }, _errorFactory));
        }; var __is = function (input) { return "object" === typeof input && null !== input && _io0(input); }; var _errorFactory; return function (input, errorFactory) {
            if (false === __is(input)) {
                _errorFactory = errorFactory;
                (function (input, _path, _exceptionable) {
                    if (_exceptionable === void 0) { _exceptionable = true; }
                    return ("object" === typeof input && null !== input || __typia_transform__assertGuard._assertGuard(true, {
                        method: "typia.assert",
                        path: _path + "",
                        expected: "FirebaseGrantRequest",
                        value: input
                    }, _errorFactory)) && _ao0(input, _path + "", true) || __typia_transform__assertGuard._assertGuard(true, {
                        method: "typia.assert",
                        path: _path + "",
                        expected: "FirebaseGrantRequest",
                        value: input
                    }, _errorFactory);
                })(input, "$input", true);
            }
            return input;
        }; })()(body); });
        return issueToken.random();
    };
})(issueToken || (exports.issueToken = issueToken = {}));
//# sourceMappingURL=index.js.map